<div class="custom-dialog-header d-flex justify-content-between p-3">
  <div class="custom-dialog-close-container">
    <button type="button" class="custom-dialog-close-btn" (click)="cancel()">
      <span class="pi pi-times"></span>
    </button>
  </div>
</div>
<div class="panel_wrapper">
  <div class="pb-4 text-center delete_message">
    <h4>{{'VENUE.DELETE_CAPACITY_GROUP' | translate}}</h4>
  </div>
  <div class="d-flex flex-row justify-content-between pb-2">
    <button class="btn_delete w_45 mt-0" (click)="deleteGroup()">{{'DELETE' | translate}}</button>
    <button class="btn_cancel w_45" (click)="cancel()">{{'CANCEL' | translate }}</button>
  </div>
</div>
